<template>
  <div class='authorizedAccount'>
    <data-list :table-style="{name:'mixture'}"
               :data="data"
               :columns="columns"></data-list>
  </div>
</template>

<script>
import website from '@/backend/services/website/website.js'

export default {
  name: 'authorizedAccount',
  props: ['scope'],
  inject: ['showForm', 'query'],
  data () {
    let that = this
    return {
      columns: [
        {
          align: 'center',
          label: 'Gmail账号',
          bind: 'account',
        },
        {
          align: 'center',
          label: '最后编辑人',
          bind: 'operator',
        },
        // {
        //   align: 'center',
        //   label: '备注',
        //   bind: 'updateAt',
        // },
        {
          align: 'center',
          label: '授权时间',
          bind: 'operateAt',
        },
        {
          label: '操作',
          type: 'btnClick',
          style: 'text',
          bind: () => {
            return [
              {
                text: '编辑',
                trigger: row => {
                  let { account, index } = row
                  that.showForm({
                    index,
                    gmailID: account,
                    ...that.scope.row
                  })
                },
              },
              {
                text: '删除',
                trigger: row => {
                  that.$confirm(`确定删除账号授权？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'danger',
                  }).then(async () => {
                    let { members, domain } = that.scope.row
                    let { index } = row
                    let membersCopy = _.cloneDeep(members);
                    membersCopy.splice(index, 1)
                    await website.addGsc({
                      domain,
                      members: membersCopy
                    })
                    this.query()
                  }).catch(() => { });
                },
              },
            ];
          },
        },
      ],
    }
  },
  computed: {
    data (self) {
      return self.scope.row.members.map((val, index) => {
        return {
          ...val,
          index
        }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
.authorizedAccount {
}
</style>
